@let items = entities();
<div class="px-[48px]">
  <div class="py-md flex gap-2">
    <h1 class="title-medium-semibold mb-0">{{ referentiel().nom }}</h1>
  </div>

  <div class="mb-6 w-1/2">
    <app-input-search (onFilter)="filtres.set($event)" placeholder="Recherchez une certification" />
  </div>

  @if (items.length) {
    <div hlmTableContainer>
      <table hlmTable>
        <thead hlmTHead>
          <tr hlmTr>
            <th hlmTh>Libellé de la certification</th>
            <th hlmTh>Niveau CEC</th>
            <th hlmTh style="min-width: 128px">État</th>
            <th hlmTh>Date de début</th>
            <th hlmTh>Date d'échéance</th>
          </tr>
        </thead>
        <tbody hlmTBody>
          @for (item of items; track item.id) {
            <tr class="hover:bg-accent cursor-pointer" [routerLink]="['..', 'croisement', item.codeFiche]" hlmTr>
              <td class="text-decoration-underline" [hlmTooltipTrigger]="item.nom" hlmTd>{{ item.nom }}</td>
              <td hlmTd>
                @if (item.niveau) {
                  Niveau {{ item.niveau }}
                }
              </td>
              <td hlmTd><app-croisement-etat [etat]="item.etatCroisement" /></td>
              <td hlmTd>{{ item.debutValidite | date: 'dd MMM yyyy' }}</td>
              <td hlmTd>{{ item.echeance | date: 'dd MMM yyyy' }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <app-paginateur [store]="store" />
  } @else if (filtres()?.nom) {
    <div class="border-grey-2 px-md pb-xxl rounded-lg border">
      <app-empty-state title="Tapez le nom d'une certification dans la barre de recherche.">
        <span class="paragraph-medium-medium text-content-secondary text-center"
          >Veuillez taper le nom d’une certification présente sur la base de données de
          <a [href]="urlFranceCompetences" hlmBtn variant="link" size="compact" target="_blank">France Compétences</a
          >.</span
        >
      </app-empty-state>
    </div>
  } @else {
    <div class="border-grey-2 px-md pb-xxl rounded-lg border">
      <app-empty-state
        isCertification
        title="Commencez à rechercher une certification grâce à la barre de recherche."
        type="certification"
      />
    </div>
  }
</div>
